<div class="wrapper">
  <header>
    <reza-header />
    @if (!hideNavbar) {
    <reza-navbar />
    }
  </header>
  @if (!hideBreadcrumb) { @if (breadcrumbs$ | async; as breadcrumbs) {
  <page-settings-breadcrumbs [breadcrumbs]="breadcrumbs" />
  } }
  <main>
    <ui-wrapper>
      <ui-router-outlet />
    </ui-wrapper>
  </main>
  <footer>
    <reza-footer [publicFooter]="publicFooter" />
    <!-- <button (click)="startCountdown()">click me</button> -->
  </footer>
</div>
<!-- <button (click)="startCountdown()">startSessionCountdown</button> -->
